import React from 'react';
import CipherLogo from './cipher_logo';
import CareProviderLogo from './care_provider_logo';
import { careProviderConfiguration } from 'store';
import { useAtom } from 'jotai';

const Logo = ({ size = 'small' }: { size?: 'large' | 'medium' | 'small' }) => {
  const [careProviderStyles] = useAtom(careProviderConfiguration);
  return careProviderStyles.logo !== 'cipherLogo'
    ? (
        <CareProviderLogo size={size} />
      )
    : (
        <CipherLogo size={size} />
      );
};

export default Logo;
